// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as LoginRouteImport } from './routes/login'
import { Route as WithOptionalSidebarRouteImport } from './routes/_with-optional-sidebar'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as GuideIndexRouteImport } from './routes/guide/index'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as PublicSupportRouteImport } from './routes/_public/support'
import { Route as PublicProRouteImport } from './routes/_public/pro'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicGroupTripPlannerRouteImport } from './routes/_public/group-trip-planner'
import { Route as PublicContactRouteImport } from './routes/_public/contact'
import { Route as PublicClaudeRouteImport } from './routes/_public/claude'
import { Route as PublicAiTripPlannerRouteImport } from './routes/_public/ai-trip-planner'
import { Route as AuthenticatedDeleteConfirmedRouteImport } from './routes/_authenticated/delete-confirmed'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as WithOptionalSidebarTripsExploreRouteImport } from './routes/_with-optional-sidebar/trips/explore'
import { Route as PublicDestinationsIndexRouteImport } from './routes/_public/destinations/index'
import { Route as PublicBlogsIndexRouteImport } from './routes/_public/blogs/index'
import { Route as PublicDestinationsSlugRouteImport } from './routes/_public/destinations/$slug'
import { Route as PublicBlogsSlugRouteImport } from './routes/_public/blogs/$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminSupportRouteImport } from './routes/_authenticated/admin/support'
import { Route as AuthenticatedAdminEmailsRouteImport } from './routes/_authenticated/admin/emails'
import { Route as WithOptionalSidebarTripShareShareTokenRouteImport } from './routes/_with-optional-sidebar/trip/share/$shareToken'
import { Route as AuthenticatedAdminUsersUserIdRouteImport } from './routes/_authenticated/admin/users.$userId'
import { Route as WithOptionalSidebarGuideSlugGuideIdIndexRouteImport } from './routes/_with-optional-sidebar/guide/$slug/$guideId/index'
import { Route as AuthenticatedTripSlugTripIdIndexRouteImport } from './routes/_authenticated/trip/$slug/$tripId/index'
import { Route as AuthenticatedTripSlugTripIdFilesRouteImport } from './routes/_authenticated/trip/$slug/$tripId/files'
import { Route as AuthenticatedTripSlugTripIdChecklistsRouteImport } from './routes/_authenticated/trip/$slug/$tripId/checklists'
import { Route as AuthenticatedGuideSlugGuideIdEditRouteImport } from './routes/_authenticated/guide/$slug/$guideId/edit'

const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const WithOptionalSidebarRoute = WithOptionalSidebarRouteImport.update({
            id: '/_with-optional-sidebar',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const GuideIndexRoute = GuideIndexRouteImport.update({
            id: '/guide/',path: '/guide/',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const PublicTermsRoute = PublicTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => PublicRoute
          })
const PublicSupportRoute = PublicSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => PublicRoute
          })
const PublicProRoute = PublicProRouteImport.update({
            id: '/pro',path: '/pro',getParentRoute: () => PublicRoute
          })
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PublicRoute
          })
const PublicGroupTripPlannerRoute = PublicGroupTripPlannerRouteImport.update({
            id: '/group-trip-planner',path: '/group-trip-planner',getParentRoute: () => PublicRoute
          })
const PublicContactRoute = PublicContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => PublicRoute
          })
const PublicClaudeRoute = PublicClaudeRouteImport.update({
            id: '/claude',path: '/claude',getParentRoute: () => PublicRoute
          })
const PublicAiTripPlannerRoute = PublicAiTripPlannerRouteImport.update({
            id: '/ai-trip-planner',path: '/ai-trip-planner',getParentRoute: () => PublicRoute
          })
const AuthenticatedDeleteConfirmedRoute = AuthenticatedDeleteConfirmedRouteImport.update({
            id: '/delete-confirmed',path: '/delete-confirmed',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRoute
          })
const WithOptionalSidebarTripsExploreRoute = WithOptionalSidebarTripsExploreRouteImport.update({
            id: '/trips/explore',path: '/trips/explore',getParentRoute: () => WithOptionalSidebarRoute
          })
const PublicDestinationsIndexRoute = PublicDestinationsIndexRouteImport.update({
            id: '/destinations/',path: '/destinations/',getParentRoute: () => PublicRoute
          })
const PublicBlogsIndexRoute = PublicBlogsIndexRouteImport.update({
            id: '/blogs/',path: '/blogs/',getParentRoute: () => PublicRoute
          })
const PublicDestinationsSlugRoute = PublicDestinationsSlugRouteImport.update({
            id: '/destinations/$slug',path: '/destinations/$slug',getParentRoute: () => PublicRoute
          })
const PublicBlogsSlugRoute = PublicBlogsSlugRouteImport.update({
            id: '/blogs/$slug',path: '/blogs/$slug',getParentRoute: () => PublicRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSupportRoute = AuthenticatedAdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEmailsRoute = AuthenticatedAdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AuthenticatedAdminRoute
          })
const WithOptionalSidebarTripShareShareTokenRoute = WithOptionalSidebarTripShareShareTokenRouteImport.update({
            id: '/trip/share/$shareToken',path: '/trip/share/$shareToken',getParentRoute: () => WithOptionalSidebarRoute
          })
const AuthenticatedAdminUsersUserIdRoute = AuthenticatedAdminUsersUserIdRouteImport.update({
            id: '/users/$userId',path: '/users/$userId',getParentRoute: () => AuthenticatedAdminRoute
          })
const WithOptionalSidebarGuideSlugGuideIdIndexRoute = WithOptionalSidebarGuideSlugGuideIdIndexRouteImport.update({
            id: '/guide/$slug/$guideId/',path: '/guide/$slug/$guideId/',getParentRoute: () => WithOptionalSidebarRoute
          })
const AuthenticatedTripSlugTripIdIndexRoute = AuthenticatedTripSlugTripIdIndexRouteImport.update({
            id: '/trip/$slug/$tripId/',path: '/trip/$slug/$tripId/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTripSlugTripIdFilesRoute = AuthenticatedTripSlugTripIdFilesRouteImport.update({
            id: '/trip/$slug/$tripId/files',path: '/trip/$slug/$tripId/files',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTripSlugTripIdChecklistsRoute = AuthenticatedTripSlugTripIdChecklistsRouteImport.update({
            id: '/trip/$slug/$tripId/checklists',path: '/trip/$slug/$tripId/checklists',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedGuideSlugGuideIdEditRoute = AuthenticatedGuideSlugGuideIdEditRouteImport.update({
            id: '/guide/$slug/$guideId/edit',path: '/guide/$slug/$guideId/edit',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminEmailsRoute: AuthenticatedAdminEmailsRoute,AuthenticatedAdminSupportRoute: AuthenticatedAdminSupportRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminUsersUserIdRoute: AuthenticatedAdminUsersUserIdRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedBillingRoute: AuthenticatedBillingRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDeleteConfirmedRoute: AuthenticatedDeleteConfirmedRoute,AuthenticatedGuideSlugGuideIdEditRoute: AuthenticatedGuideSlugGuideIdEditRoute,AuthenticatedTripSlugTripIdChecklistsRoute: AuthenticatedTripSlugTripIdChecklistsRoute,AuthenticatedTripSlugTripIdFilesRoute: AuthenticatedTripSlugTripIdFilesRoute,AuthenticatedTripSlugTripIdIndexRoute: AuthenticatedTripSlugTripIdIndexRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const PublicRouteChildren = {
  PublicAiTripPlannerRoute: PublicAiTripPlannerRoute,PublicClaudeRoute: PublicClaudeRoute,PublicContactRoute: PublicContactRoute,PublicGroupTripPlannerRoute: PublicGroupTripPlannerRoute,PublicPrivacyRoute: PublicPrivacyRoute,PublicProRoute: PublicProRoute,PublicSupportRoute: PublicSupportRoute,PublicTermsRoute: PublicTermsRoute,PublicIndexRoute: PublicIndexRoute,PublicBlogsSlugRoute: PublicBlogsSlugRoute,PublicDestinationsSlugRoute: PublicDestinationsSlugRoute,PublicBlogsIndexRoute: PublicBlogsIndexRoute,PublicDestinationsIndexRoute: PublicDestinationsIndexRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)




const WithOptionalSidebarRouteChildren = {
  WithOptionalSidebarTripsExploreRoute: WithOptionalSidebarTripsExploreRoute,WithOptionalSidebarTripShareShareTokenRoute: WithOptionalSidebarTripShareShareTokenRoute,WithOptionalSidebarGuideSlugGuideIdIndexRoute: WithOptionalSidebarGuideSlugGuideIdIndexRoute
}

const WithOptionalSidebarRouteWithChildren = WithOptionalSidebarRoute._addFileChildren(WithOptionalSidebarRouteChildren)

const rootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,PublicRoute: PublicRouteWithChildren,WithOptionalSidebarRoute: WithOptionalSidebarRouteWithChildren,LoginRoute: LoginRoute,SignUpRoute: SignUpRoute,GuideIndexRoute: GuideIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)